import './Research.css';
import { useNavigate } from 'react-router-dom';
import brain2 from './brain-2.jpg';
import brain3 from './brain-3.jpg';
import generative1 from './generative.jpg';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar.js';
import Footer from './footer.js';
import video_brain from './brain-2.mp4';
import video_brain2 from './brain-3.mp4';
import video_brain3 from './brain-4.mp4';

const Research = () => {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const [highlighted, setHighlighted] = useState('');

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      setHighlighted(id);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
    const clearHighlight = () => {
      setHighlighted('');
    };
    document.addEventListener('click', clearHighlight);
    return () => {
      document.removeEventListener('click', clearHighlight);
    };
  }, [hash]);

  return (
    <div className="page-container">
      <Navbar />
      
      <main className="content-wrapper">
        <div className="research-content">
          <h1>Cnyda Dynamics Research Division</h1>
          <p>
            The company primarily focuses on conducting research in a wide range of fields, 
            including cutting-edge technologies, advanced applied mathematics, international/macro economics, 
            and cognitive behavioral sciences with the aim of expanding human knowledge and driving positive change. Currently, 
            the company is devoting its efforts to designing novel AI architectures that deviate from the conventional generative AI approaches.
            While generative AI has garnered significant hype and has many promising use cases like language translation, image generation, 
            customer service agent, information retrieval and code generation but it struggles with tasks that demand sophisticated thinking abilities and is inadequate for tasks that require exceptionally high reliability/accuracy.
            It is well known that generative AI models are notorious liars, they miserably fail in tasks requiring six-sigma standards (around 3 errors in one million decisions).
            The organization is tirelessly working towards developing AI models of the highest caliber,boasting an unprecedented six-sigma reliability that guarantees absolute truthfulness.
          </p>
        </div>

        <div className="card-container_research">
          <div 
            id="Economic-Research" 
            className={`card_research ${highlighted === 'Economic-Research' ? 'highlight-glow' : ''}`}>
           <video src={video_brain} className="card-image_research" autoPlay loop muted playsInline/>
            <div className="card-content_research">
              <h1 className="card-title_research">Economic Research:</h1>
              <p className="card-text_research">
                The objective of this economic research is to critically review an international research book that predicted the world economy a decade ahead.
              </p>
              <button className="card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/Economic-Research'); }} >Read More</button>
            </div>
          </div>
        </div>

        <div className="card-container_research">
          <div 
            id="Digital_Brain_Research" 
            className={`card_research ${highlighted === 'Digital_Brain_Research' ? 'highlight-glow' : ''}`}>
             <video 
              src={video_brain2} 
              className="card-image_research" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="card-content_research">
              <h1 className="card-title_research">Digital Brain Research:</h1>
              <p className="card-text_research">
                Exploring the mathematical foundations of rational brain structure through the lens of neuro-science, epistemology, and the Philosophy of mind
              </p>
              <button className="card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/Digital_Brain_Research'); }} >Read More</button>
            </div>
          </div>
        </div>

        <div className="card-container_research">
          <div 
            id="generative" 
            className={`card_research ${highlighted === 'generative' ? 'highlight-glow' : ''}`}>
             <video 
              src={video_brain3} 
              className="card-image_research" 
              autoPlay 
              loop 
              muted 
              playsInline
            />
            <div className="card-content_research">
              <h1 className="card-title_research">Generative AI Research:</h1>
              <p className="card-text_research">
                The aim of this research is to find an optimal parameter small LLM model which can do as many language tasks as possible with minimum compute
              </p>
              <button className="card-btn_research" onClick={(e) => { e.stopPropagation(); handleNavigation('/generative'); }} >Read More</button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Research;